<form [formGroup]="myForm" class="column">
  <p class="uk-text-body-strong">Para continuar registré la autorización de un administrador</p>
  <mat-radio-group
    *ngIf="authorizationType"
    class="d-flex flex-column col-12 mt-3 mb-2"
    formControlName="action"
  >
    <mat-radio-button class="mb-2" id="settingsAllShippings" value="code">
      Autorización por código
    </mat-radio-button>
    <mat-radio-button class="mb-2" id="settingsOneShipping" value="user">
      Autorización con la cuenta del administrador
    </mat-radio-button>
  </mat-radio-group>
  <ng-container
    *ngIf="myForm.controls['action'].value !== 'code';
      else elseTemplate
    "
  >
    <mat-form-field class="col-12 col-md-12">
      <mat-label>Usuario</mat-label>
      <input
        matInput
        formControlName="username"
        id="updatePrices-user"
        autocomplete="off"
        min="4"
        required
      />
      <mat-icon matSuffix class="icon-visibility">person</mat-icon>
    </mat-form-field>
    <br />
    <mat-form-field class="col-12 col-md-12">
      <mat-label>Contraseña</mat-label>
      <input
        matInput
        formControlName="password"
        id="updatePrices-password"
        [type]="hidePassword ? 'password' : 'text'"
        autocomplete="new-password"
        (keyup.enter)="onClick()"
        min="4"
        required
      />
      <mat-icon
        matSuffix
        id="hidePassword"
        class="icon-visibility"
        (click)="hidePassword = !hidePassword"
        >
          {{ hidePassword ? "visibility_off" : "visibility" }}
        </mat-icon>
    </mat-form-field>
  </ng-container>
  <ng-template #elseTemplate>
    <mat-form-field class="col-12">
      <mat-label>Código de autorización</mat-label>
      <input
        id="codControl"
        matInput
        formControlName="codControl"
        maxlength="8"
        autocomplete="off"
        (keyup.enter)="onClick()"
      />
      <mat-icon matSuffix (click)="onClick()">load</mat-icon>
    </mat-form-field>
  </ng-template>
</form>
